var _g, _g2, _path, _path2, _path3, _g3, _path4, _g4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 172,
    viewBox: "0 0 139 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_402_561)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.0005,
    y: 32.8902,
    width: 89.751,
    height: 106.069,
    rx: 4.89551,
    fill: "url(#paint0_linear_402_561)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_402_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9727 132.825V132.334L43.1035 132.094L42.955 132.3V125.389L43.1378 125.606L41.9727 125.4V124.909L44.8855 124.852V125.343L43.7318 125.606L43.8917 125.389V128.587L43.7204 128.416H48.1981L48.0268 128.587V125.389L48.1981 125.606L47.0444 125.4V124.909L49.9572 124.852V125.343L48.8149 125.606L48.9634 125.389V132.3L48.8149 132.094L49.9572 132.334V132.825H47.0444V132.334L48.1753 132.094L48.0268 132.3V128.953L48.1981 129.113H43.7204L43.8917 128.953V132.3L43.7432 132.094L44.8855 132.334V132.825H41.9727Z",
    fill: "url(#paint1_linear_402_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4674 132.928C52.9572 132.928 52.5041 132.814 52.1081 132.585C51.7197 132.349 51.4151 132.007 51.1943 131.557C50.9734 131.108 50.863 130.56 50.863 129.912C50.863 129.25 50.9773 128.679 51.2057 128.199C51.4342 127.719 51.7578 127.35 52.1767 127.091C52.5955 126.824 53.0867 126.691 53.6502 126.691C54.1833 126.691 54.6211 126.805 54.9638 127.034C55.3141 127.255 55.573 127.563 55.7406 127.959C55.9157 128.355 56.0033 128.808 56.0033 129.318C56.0033 129.402 55.9995 129.486 55.9919 129.57C55.9843 129.653 55.9728 129.756 55.9576 129.878H51.5598V129.227H55.158L55.0552 129.296C55.0628 128.953 55.0209 128.637 54.9296 128.347C54.8382 128.058 54.6821 127.826 54.4612 127.651C54.2404 127.476 53.9472 127.388 53.5817 127.388C53.1933 127.388 52.8658 127.491 52.5993 127.696C52.3328 127.902 52.1348 128.184 52.0053 128.542C51.8759 128.9 51.8111 129.315 51.8111 129.787C51.8111 130.289 51.8835 130.723 52.0282 131.089C52.1728 131.447 52.3823 131.725 52.6564 131.923C52.9382 132.121 53.2809 132.22 53.6845 132.22C53.9662 132.22 54.2746 132.166 54.6097 132.06C54.9448 131.946 55.2913 131.774 55.6492 131.546L55.9805 132.06C55.554 132.349 55.1276 132.566 54.7011 132.711C54.2747 132.856 53.8634 132.928 53.4674 132.928Z",
    fill: "url(#paint2_linear_402_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6905 132.311L61.542 132.106L62.5929 132.311V132.814L60.9937 132.882L60.8566 131.786L60.9366 131.82C60.6015 132.186 60.2398 132.463 59.8514 132.654C59.463 132.837 59.0861 132.928 58.7205 132.928C58.2788 132.928 57.9057 132.787 57.6011 132.505C57.2965 132.224 57.1442 131.797 57.1442 131.226C57.1442 130.777 57.2394 130.434 57.4297 130.198C57.6201 129.954 57.8828 129.783 58.2179 129.684C58.553 129.585 58.9414 129.535 59.383 129.535H60.8794L60.7766 129.65V128.553C60.7766 128.134 60.6662 127.837 60.4454 127.662C60.2245 127.479 59.9199 127.388 59.5315 127.388C59.3259 127.388 59.1051 127.411 58.869 127.456C58.6406 127.495 58.3969 127.559 58.138 127.651L58.275 127.502L58.1608 128.542H57.5554L57.464 127.125C57.8981 126.981 58.3055 126.874 58.6862 126.805C59.067 126.729 59.4173 126.691 59.7372 126.691C60.3464 126.691 60.8223 126.828 61.165 127.102C61.5153 127.369 61.6905 127.799 61.6905 128.393V132.311ZM58.0694 131.146C58.0694 131.519 58.157 131.793 58.3321 131.969C58.5149 132.144 58.7434 132.231 59.0175 132.231C59.284 132.231 59.5772 132.151 59.8971 131.991C60.2245 131.824 60.5406 131.599 60.8452 131.317L60.7766 131.557V130.027L60.8794 130.129H59.5201C58.9794 130.129 58.6025 130.213 58.3893 130.381C58.176 130.541 58.0694 130.796 58.0694 131.146Z",
    fill: "url(#paint3_linear_402_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8989 132.243L64.796 132.117L65.7898 132.334V132.825H63.0826V132.334L64.0764 132.117L63.985 132.243V124.681L64.0764 124.784L63.0826 124.578V124.087L64.8989 124.007V132.243Z",
    fill: "url(#paint4_linear_402_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5217 132.928C68.1257 132.928 67.8135 132.806 67.585 132.562C67.3566 132.311 67.2423 131.934 67.2423 131.432V127.285L67.3908 127.434H66.2143V126.931L67.4022 126.76L67.2423 126.942V125.435L68.1562 125.286V126.942L68.0305 126.794H69.8239L69.7896 127.434H68.0305L68.1562 127.285V131.306C68.1562 131.626 68.2171 131.858 68.3389 132.003C68.4684 132.147 68.6473 132.22 68.8758 132.22C69.0129 132.22 69.1614 132.197 69.3213 132.151C69.4812 132.106 69.6525 132.041 69.8353 131.957L70.0295 132.483C69.4888 132.78 68.9862 132.928 68.5217 132.928Z",
    fill: "url(#paint5_linear_402_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3669 132.825V132.334L71.4064 132.106L71.2693 132.277V124.624L71.4064 124.806L70.3669 124.578V124.087L72.1832 124.007V127.868L71.9775 127.822C72.3507 127.434 72.7429 127.148 73.1541 126.965C73.5729 126.783 73.9689 126.691 74.3421 126.691C74.6771 126.691 74.9779 126.76 75.2445 126.897C75.511 127.034 75.7166 127.243 75.8613 127.525C76.0136 127.799 76.0898 128.149 76.0898 128.576V132.277L75.9755 132.117L76.9807 132.334V132.825H74.3192V132.334L75.3016 132.117L75.1759 132.288V128.782C75.1836 128.309 75.0769 127.963 74.8561 127.742C74.6353 127.521 74.3459 127.411 73.988 127.411C73.7138 127.411 73.4092 127.487 73.0741 127.639C72.7391 127.792 72.4154 128.031 72.1032 128.359L72.1832 128.165V132.288L72.0689 132.128L73.0399 132.334V132.825H70.3669Z",
    fill: "url(#paint6_linear_402_561)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9145 58.2515C77.9106 56.8583 76.778 55.732 75.3849 55.7359C74.8188 55.7375 74.2979 56.2841 73.8779 56.6001C73.4562 56.2865 72.9321 55.7427 72.3661 55.7443C70.9729 55.7482 69.8467 56.8807 69.8506 58.2739C69.8543 59.6111 73.8944 62.5123 73.8944 62.5123C73.8944 62.5123 77.9182 59.5886 77.9145 58.2515Z",
    fill: "#FF3F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9555 62.5124C73.9555 62.5124 77.9793 59.5887 77.9756 58.2515C77.9716 56.8583 76.8391 55.732 75.4459 55.7359C74.8799 55.7375 74.359 56.2841 73.939 56.6001L73.9555 62.5124Z",
    fill: "#FF0C38"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_402_561)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_402_561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 58,
    width: 15,
    height: 38
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5222 72.8716H69.4426V67.5682L59.2437 63.0806V58.5931L73.5222 64.7125V72.8716ZM73.5222 74.9114V76.3393C73.5222 85.3144 65.975 95.3094 59.2437 95.3094V91.2298C63.3232 91.2298 69.4426 83.2746 69.4426 76.3393V74.9114H73.5222Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_402_561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0454 105.508H83.7219V48.3939H49.0454V105.508Z",
    fill: "#E8B05E"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_402_561)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_402_561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 58,
    width: 15,
    height: 38
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3851 78.991H45.3055C45.1016 78.1751 45.1016 77.1552 45.1016 76.3393V64.7125L59.3801 58.5931V63.0806L49.1812 67.5682V76.5433C48.9772 77.1552 49.1812 78.1751 49.3851 78.991ZM49.7931 81.0308C51.6289 86.3343 56.1165 91.2298 59.1761 91.2298V95.3094C53.6687 95.3094 47.5493 88.3741 45.5095 81.0308H49.7931Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_402_561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6982 105.508H69.3748V48.3939H34.6982V105.508Z",
    fill: "#F6BC66"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6775 76.9496H38.8467V78.9894H51.6974L55.165 73.89L61.2844 86.3327L65.976 76.9496H79.6426V74.9099H64.7521L61.2844 81.8452L55.369 69.8104L50.6775 76.9496Z",
    fill: "#F4B742"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_402_561",
    x: -16.6362,
    y: 0.253479,
    width: 155.024,
    height: 171.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_561",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_402_561",
    x: 9.33594,
    y: 94.6337,
    width: 100.282,
    height: 74.1947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_561",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_402_561",
    x: 26.6069,
    y: 29.22,
    width: 79.5518,
    height: 101.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.717647 0 0 0 0 0.258824 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_561",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_402_561",
    x: 12.4648,
    y: 29.22,
    width: 79.5518,
    height: 101.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.717647 0 0 0 0 0.258824 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_561",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_561",
    x1: 60.876,
    y1: 32.8902,
    x2: 60.876,
    y2: 138.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#2C2C2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_561",
    x1: 32.6239,
    y1: 135.825,
    x2: 86.0177,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_561",
    x1: 32.6239,
    y1: 135.825,
    x2: 86.0177,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_561",
    x1: 32.6239,
    y1: 135.825,
    x2: 86.0177,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_561",
    x1: 32.6239,
    y1: 135.825,
    x2: 86.0177,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_561",
    x1: 32.6239,
    y1: 135.825,
    x2: 86.0177,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_561",
    x1: 32.6239,
    y1: 135.825,
    x2: 86.0177,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.dd940deec0c87fc58bffdceb7db6aa5f.svg";
export { ForwardRef as ReactComponent };